<template>
  <b-form-group>
    <el-upload class="avatar-uploader" :action="action" :data="data"
      :show-file-list="false" :accept="accept_types"
      :on-success="handleSuccess"
      :before-upload="beforeUpload">
      <b-button size="sm" variant="outline-success">点击上传</b-button>
    </el-upload>
    <b-img v-if="!uploaded" :src="fileObj" ref="img" class="avatar mt-1" @error="setDefaultImg"/>
    <b-img v-else :src="imgUrl" class="avatar mt-1" />
  </b-form-group>
</template>

<style scoped>
  .el-upload {text-align: left}
  .avatar {
    width: 178px !important;
    height: 178px;
    display: block;
  }
</style>

<script>
import api from '@/utils/api'
import consts from '@/utils/consts'

export default {
  name: 'image-upload',
  props: ['fileObj'],
  data () {
    return {
      accept_types: consts.ACCEPT_TYPES,
      action: api.getFpUpload(),
      data: {
        Authorization: '',
        fpfile: ''
      },
      imgUrl: '',
      uploaded: false
    }
  },
  created () {
    this.getFpToken()
  },
  methods: {
    getFpToken () {
      this.$ajax.get(api.getFpToken(consts.FP_TYPE)).then((res) => {
        this.data.Authorization = res.token
      })
    },
    handleSuccess (resp, file) {
      this.$emit(
        'update:fileObj', {
          body: resp.body,
          sign: resp.headers['X-Ntes-Signature'],
          file_type: consts.FP_TYPE
        }
      )
      if (resp.status !== 200) {
        this.$message.error('上传失败')
      } else {
        let respBody = JSON.parse(resp.body)
        this.imgUrl = respBody.url
        this.uploaded = true
      }
    },
    beforeUpload (file) {
      if (file.size / 1024 / 1024 > 10) {
        this.$message.error('上传图片大小不可超过10M')
        return false
      }
      this.data.fpfile = file
      return true
    },
    setDefaultImg () {
      this.$refs.img.src = consts.DEFAULT_IMG_URL
    }
  }
}
</script>



// WEBPACK FOOTER //
// ImageUpload.vue?06502b14